import { render } from "./SpacesGroups.vue?vue&type=template&id=73acee0d&scoped=true&ts=true"
import script from "./SpacesGroups.vue?vue&type=script&lang=ts"
export * from "./SpacesGroups.vue?vue&type=script&lang=ts"

import "./SpacesGroups.vue?vue&type=style&index=0&id=73acee0d&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73acee0d"]])

export default __exports__